// Getters
export const payment = (state) => {
  return state.payment.data || []
}
export const paymentLoading = (state) => {
  return state.payment.loading
}
export const paymentLastUpdate = (state) => {
  return state.payment.lastUpdate
}

export const stockOption = (state) => {
  return state.stockOption.data || []
}
export const stockOptionLoading = (state) => {
  return state.stockOption.loading
}
export const stockOptionLastUpdate = (state) => {
  return state.stockOption.lastUpdate
}
export const kitPartners = (state) => {
  return state.kitPartners.data || []
}
export const kitPartnersLoading = (state) => {
  return state.kitPartners.loading
}
export const kitPartnersLastUpdate = (state) => {
  return state.kitPartners.lastUpdate
}

export const statusKitPartners = (state) => {
  return state.statusKitPartners.data || []
}
export const statusKitPartnersLoading = (state) => {
  return state.statusKitPartners.loading
}
export const statusKitPartnersLastUpdate = (state) => {
  return state.statusKitPartners.lastUpdate
}

export const statusKitClients = (state) => {
  return state.statusKitClients.data || []
}
export const statusKitClientsLoading = (state) => {
  return state.statusKitClients.loading
}
export const statusKitClientsLastUpdate = (state) => {
  return state.statusKitClients.lastUpdate
}

export const documentsKitPartners = (state) => {
  return state.documentsKitPartners.data || []
}
export const documentsKitPartnersLoading = (state) => {
  return state.documentsKitPartners.loading
}
export const documentsKitPartnersLastUpdate = (state) => {
  return state.documentsKitPartners.lastUpdate
}

export const tipoKitPartners = (state) => {
  return state.tipoKitPartners.data || []
}
export const tipoKitPartnersLoading = (state) => {
  return state.tipoKitPartners.loading
}
export const tipoKitPartnersLastUpdate = (state) => {
  return state.tipoKitPartners.lastUpdate
}

export const professionalKitPartners = (state) => {
  return state.professionalKitPartners.data || []
}
export const professionalKitPartnersLoading = (state) => {
  return state.professionalKitPartners.loading
}
export const professionalKitPartnersLastUpdate = (state) => {
  return state.professionalKitPartners.lastUpdate
}

export const clientKitPartners = (state) => {
  return state.clientKitPartners.data || []
}
export const clientKitPartnersLoading = (state) => {
  return state.clientKitPartners.loading
}
export const clientKitPartnersLastUpdate = (state) => {
  return state.clientKitPartners.lastUpdate
}

export const conjuntoKitPartners = (state) => {
  return state.conjuntoKitPartners.data || []
}
export const conjuntoKitPartnersLoading = (state) => {
  return state.conjuntoKitPartners.loading
}
export const conjuntoKitPartnersLastUpdate = (state) => {
  return state.conjuntoKitPartners.lastUpdate
}

export const opcoesKitPartners = (state) => {
  return state.opcoesKitPartners.data || []
}
export const opcoesKitPartnersLoading = (state) => {
  return state.opcoesKitPartners.loading
}
export const opcoesKitPartnersLastUpdate = (state) => {
  return state.opcoesKitPartners.lastUpdate
}

export const pjKitPartners = (state) => {
  return state.pjKitPartners.data || []
}
export const pjKitPartnersLoading = (state) => {
  return state.pjKitPartners.loading
}
export const pjKitPartnersLastUpdate = (state) => {
  return state.pjKitPartners.lastUpdate
}

export const vinculoKitPartners = (state) => {
  return state.vinculoKitPartners.data || []
}
export const vinculoKitPartnersLoading = (state) => {
  return state.vinculoKitPartners.loading
}
export const vinculoKitPartnersLastUpdate = (state) => {
  return state.vinculoKitPartners.lastUpdate
}
